import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { MdReport } from "react-icons/md";
import { FaToolbox } from "react-icons/fa";
import Moment from "moment";
import { DownloadShipDetails } from "../Actions/ClientDashboardAPI"
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { DownloadAttachment } from "../Actions/AttachmentAPI";
import { downloadShipEquipmentStatus } from "../Actions/ShipEquipmentDetailsAPI";
import moment from "moment";


class ShipCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
    };
  }

  renderPopover(props) {
    const{t}=this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{t("content.DownloadStatus")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  renderbudgetover(props) {
    const{t}=this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{t("content.BudgetListScreen")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  renderShipService(props) {
    const{t}=this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>
          {t("content.EquipmentServiceDetailsScreen")}
          </label>
        </Popover.Content>
      </Popover>
    );
  }

  render() {
    const { arraylist, pageSize, totalRecords,t } = this.props;
    return (
      <div className="pb-3">
        {this.renderCardData()}
        {arraylist.data.length != 0 ? (
          <Paginator
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relNative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
              {t("CommonText.NoItem")}
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }

  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1,2,true);
  }
  gotobudgetscreen = (shipId) => {
    this.props.history.push(`/Home/BudgetListEdit/${shipId}`);
  };
  Gotoservicescreen = (shipId) => {
    this.props.history.push(`/Home/ServiceUpdateList/${shipId}`);
  };

  renderCardData = () => {
    const { arraylist,t,isContract,isBoth } = this.props;
    return arraylist.data && arraylist.data.length
      ? arraylist.data.map((item, index) => {
        return (
          <div
            className="card mb-1"
            style={{ overflow: "hidden", position: "relative" }}
          >
 
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-10 col-md-10 col-10 col-m-auto">
                    <div className="row">
                      <div className="col-sm-3 col-md-3 pb-2">
                        <h6 className="resource-list-title" onClick={() => this.ShowSidePanel(item.shipId)}>
                          {item.shipName !== "" ? item.shipName : ""}
                        </h6>
                      </div>
                      <div className="tip_data col-sm-7"
                        id="popup-trigger"
                        onClick={() => this.setPopup(item.shipId)}
                        style={{ cursor: "pointer" }}>
                        <span>
                          <strong>{t("content.Destination")} : </strong>
                          <i aria-hidden="true"></i>
                          <span className="lato ">
                            {item.destination?? "Destination"}
                          </span>
                        </span>
                        <bold className="p-2">|</bold>
                        <span>
                          <strong> {t("content.ETA")}: </strong>
                          <i aria-hidden="true"></i>
                          <span className="lato ">
                          {item.eta ? moment(item.eta).format("DD MMM YYYY") : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-3">
                        <span>
                          <strong>{t("content.TotalEquipment")}: </strong>
                          <span className="italicFont " >
                            {item.total ? item.total : 0}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-3">
                        <span>
                          <strong> {t("content.OverDueEquipment")}: </strong>
                          <span className="italicFont " >
                            {item.overDue ? item.overDue : 0}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-3">
                        <span>
                          <strong>{t("content.EquipmentDuein30Days")}: </strong>
                          <span className="italicFont " >
                            {item.in30Days ? item.in30Days : 0}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-3">
                        <span>
                          <strong>{t("content.EquipmentDuein90Days")}: </strong>
                          <i aria-hidden="true"></i>
                          <span className="italicFont " >
                            {item.in90Days ? item.in90Days : 0}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-2 col-md-2 col-lg-2 text-center pl-0">
                    <div className="col-sm-12 px-0">
                    <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={this.renderbudgetover()}
                          >
                            <MdReport
                              className="px-1 click"
                              style={{
                                color: "rgb(26, 52, 100)",
                                fontSize: "2.4rem",
                                marginTop: "-10px",
                              }}
                              onClick={() => this.gotobudgetscreen(item.shipId)}
                            />
                          </OverlayTrigger>
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderShipService()}>
                          <FaToolbox
                            className="px-1 click"
                            style={{
                              color: "rgb(26, 52, 100)",
                              fontSize: "2.2rem",
                              marginTop: "-14px",
                            }}
                            onClick={() => this.Gotoservicescreen(item.shipId)}
                          />
                        </OverlayTrigger>
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={this.renderPopover()}
                    >
                      <i
                        className="fa fa-download click px-1"
                        aria-hidden="true"
                        style={{ color: " #1a3464", fontSize: '1.5rem' }}
                        onClick={() =>
                          this.downloadDocument(item.shipId, item.shipName,isContract,isBoth)
                        }>
                      </i>
                    </OverlayTrigger>
                    <i
                      className="fa fa-eye click px-1"
                      aria-hidden="true"
                      style={{ color: " #1a3464", fontSize: '1.8rem' }}
                      onClick={() =>
                        this.ShowSidePanel(item.shipId)
                      }>
                    </i>
                </div>
                  </div>
                </div>
              </div>
            </div>
          </div >
        );
      })
      : null;
  };

  ShowSidePanel = (shipId) => {
    this.props.dispatch({ type: "ShowShipDetails", data: true });
    this.props.dispatch({ type: "Shipment Library", data: false });
    // this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
    this.props.history.push(`/Home/ShipDetails/${shipId}`);
  };

  downloadDocument(shipId, shipName,contract,both) {
    const { dispatch } = this.props;
    dispatch(downloadShipEquipmentStatus(shipId, shipName,contract,both));
  }
  setPopup = (shipId) => {
    this.props.dispatch({ type: "MapPopup", data: shipId });
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipCard)));
